export class IdName {
    id : number;
    name: string;
    desc: string;
    codeName: string;
    expanded: true;
}
